export default { 
  name : 'Parent Device ESN',
  objectType : 'globalstar',
  valueType : 'string',
  displayName : 'Parent Device ESN',
  get : () => null
}
